import React from 'react';
import PropTypes from 'prop-types';

const Loading = (props) => {
    return (
        <div
            className={`location-finder__loading-overlay ${props.loading
                ? 'active'
                : ''}`}
        >
            <div className="overlay" />
            <span className="loader" />
        </div>
    );
};

Loading.propTypes = {
    loading: PropTypes.bool.isRequired,
};

export default Loading;



// WEBPACK FOOTER //
// ./static/js/modules/locations-finder/Loading.js